import React, {
  ReactElement,
  useEffect,
  useState,
  useRef, useCallback, useMemo,
} from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Box from '@mui/material/Box';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { Page } from '../../Page/Page';
import styles from '../../Document/styles.module.css';
import Table from '../../Table/NewTable';
import { serviceReservationAddNew } from '../../../schema/serviceReservationAddNew';
import { SlidingPane } from '../../Page/SlidingPane';
import { serviceReservationViewTable } from '../../../schema/serviceReservationViewTable';
import { SlidingPaneAddNew } from '../../Page/SlidingPaneAddNew';
import api from '../../../services/api';
import { useStateContext } from '../../../hooks/useStateContext';
import {SocketProvider} from "../../../contexts/SocketContext";
import Paper, {PaperProps} from "@mui/material/Paper";
import Draggable from "react-draggable";
import {v4 as uuidv4} from "uuid";
import {DragHandleRounded, DragIndicatorRounded} from "@mui/icons-material";
export const ServiceReservationTable = ({
                                    handleClose,
                                    row,
                                  }: {
  handleClose: () => void;
  row: any;
}): ReactElement => {

  const [loading, setLoading] = useState<any>(false);
  const [fullWidth, setFullWidth] = useState(false);
  const panelRef: any = useRef(null);
  const [width, setWidth] = useState(40);
  const [serviceReservationSchema, setServiceReservationSchema] = useState(
    serviceReservationViewTable
  );
  const [view, setView] = useState<any>(undefined);
  const { user } = useStateContext();
  const searchParams = React.useMemo(() => {
    const searchParams = new URLSearchParams();
    return searchParams;
  }, []);
  const slidingPaneRef = useRef<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>(undefined);

  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({
    schema: serviceReservationSchema,
    row: {},
  });
  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: serviceReservationSchema,
    row: row ? row : {},
  });

  useEffect(() => {
    setLoading(true);
    api.get(`/users/${user.id}/views/service_reservations`).then((res) => {
      setLoading({ ...loading, ['table']: false });
      setView(res);
    });
  }, []);

  const handlePanelWidth = (fullWidth: boolean) => {
    setFullWidth(fullWidth);

    if (panelRef.current) {
      panelRef.current.resize(fullWidth ? 100 : width);
    }
  };

  const openSlidingPaneHandle = (
    row: any,
    schema: any,
    newEntity?: boolean,
    openInFull?: boolean,
    tab?: string
  ) => {
    if (newEntity) {
      setOpenedSlidingPaneAddNew({
        schema: schema,
        row: row === undefined ? {} : row,
        tab: tab,
      });
    } else {
      setOpenedSlidingPane({
        schema: serviceReservationSchema,
        row: row === undefined ? {} : row,
      });
    }

    handlePanelWidth(!!openInFull);
  };

  const mainFunctionRef: any = React.useRef(null);
  const handleRefreshMainTableData = () => {
    mainFunctionRef.current();
  };

  const handleKickEvent = (data: any) => {
    console.log('Kick event received in parent component:', data);

    if (data.table === serviceReservationSchema?.viewTable) {
      if (slidingPaneRef.current) {
        slidingPaneRef.current.onSubmit();
      }
    }

  };

  return (
    <>
      <SocketProvider
        schema={serviceReservationSchema}
        onKick={handleKickEvent}
      >
        <Box
          sx={{
            p: '0px',
            height: '100%',
          }}
        >
          <PanelGroup direction="horizontal">
            <Panel>
              <Page title={'adsasd'}>
                {() => {
                  return (
                    <PanelGroup
                      key={1}
                      autoSaveId="example"
                      direction="vertical"
                    >
                      <Panel
                        className={`${styles.Panel}`}
                        collapsible={true}
                        defaultSize={100}
                        order={1}
                      >
                        {view ? (
                          <>
                            <Table
                              setFunctionRef={(ref: any) => {
                                return (mainFunctionRef.current = ref);
                              }}
                              searchParams={searchParams}
                              columnMask={view.columns.reduce(
                                (acc: any, column: any) => {
                                  return {
                                    ...acc,
                                    [column.name]: true,
                                  };
                                },
                                {}
                              )}
                              schema={serviceReservationSchema}
                              onRowSelected={setSelectedRow}
                              isView={true}
                              viewId={view.id}
                              pins={view?.pins}
                              selectedRowId={selectedRow}
                              setCurrentEditedRow={(
                                row: any,
                                openInFull?: boolean
                              ) => {
                                openSlidingPaneHandle(
                                  row,
                                  serviceReservationSchema,
                                  false,
                                  openInFull
                                );
                              }}
                              setCurrentAddNewRow={(row: any) => {
                                openSlidingPaneHandle(
                                  row,
                                  serviceReservationAddNew,
                                  true
                                );
                              }}
                              reservationDialog={row}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </Panel>
                    </PanelGroup>
                  );
                }}
              </Page>
            </Panel>
            {openedSlidingPane?.row?.id && (
              <>
                <PanelResizeHandle
                  className={`${styles.ResizeHandleOuter} bg-[#ddd]`}
                >
                  <div className={styles.ResizeHandleInner}>
                    <svg className={styles.Icon} viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z"
                      />
                    </svg>
                  </div>
                </PanelResizeHandle>
                <Panel
                  className={`${styles.Panel}`}
                  collapsible={false}
                  minSize={20}
                  defaultSize={fullWidth ? 100 : 40}
                  ref={panelRef}
                >
                  <SlidingPane
                    ref={slidingPaneRef}
                    isDialog={true}
                    setFullWidthProp={(value) => {
                      handlePanelWidth(value);
                    }}
                    fullWidth={fullWidth}
                    schema={openedSlidingPane?.schema}
                    id={
                      openedSlidingPane?.hasOwnPane
                        ? undefined
                        : openedSlidingPane?.row?.id
                    }
                    onSubmit={() => {
                      handleRefreshMainTableData();
                      setOpenedSlidingPane({
                        schema: serviceReservationSchema,
                        row: {},
                      });
                    }}
                    propertiesFromTable={
                      openedSlidingPane?.row ? openedSlidingPane?.row : {}
                    }
                    onClose={(value) => {
                      if (
                        openedSlidingPane?.schema?.viewTable ===
                        'activity_reservation'
                      ) {
                        serviceReservationSchema.client
                          .deleteLock(value?.id, {
                            schema: JSON.stringify(
                              openedSlidingPane?.schema.client
                            ),
                          })
                          .then((result: any) => {
                          });
                      } else {
                      }
                      setOpenedSlidingPane({
                        schema: serviceReservationSchema,
                        row: {},
                      });
                    }}
                    addNewRow={(schema: any, tab: any) => {
                      openSlidingPaneHandle(
                        {
                          id: 'new',
                          group: openedSlidingPane?.row,
                        },
                        schema,
                        true,
                        false,
                        tab
                      );
                    }}
                  />
                </Panel>
              </>
            )}
          </PanelGroup>
        </Box>
      </SocketProvider>
      {openedSlidingPaneAddNew?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={openedSlidingPaneAddNew?.schema}
            id={openedSlidingPaneAddNew?.row?.id}
            onSubmit={() => {
              setOpenedSlidingPaneAddNew({
                schema: serviceReservationSchema,
                row: {},
              });
              handleRefreshMainTableData();
            }}
            propertiesFromTable={row ? row :{}}
            onClose={(value) => {
              setOpenedSlidingPaneAddNew({
                schema: serviceReservationSchema,
                row: {},
              });
            }}
          />
        </>
      )}
    </>
  );
};
